"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[17458,8112],{

/***/ 8112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tp": function() { return /* binding */ ACCEPTED_IMG_EXTENSIONS; },
  "Qz": function() { return /* binding */ INDONESIA_CITY_LIST; },
  "ep": function() { return /* binding */ INDONESIA_PREFERRED_CITY_LIST; },
  "kd": function() { return /* binding */ MAX_IMG_SIZE; },
  "N7": function() { return /* binding */ NAVIGATION_ITEMS; },
  "CJ": function() { return /* binding */ PROGRESS_STATUS_ENUM; },
  "_T": function() { return /* binding */ SHARE_TRADE_PREVIEW; },
  "oE": function() { return /* binding */ SUCCESS_CONTENT; },
  "Mz": function() { return /* binding */ WORDING_FORMAT_EMAIL_WRONG; }
});

// UNUSED EXPORTS: DEFAULT_AVATAR, MONTHS

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/global/Icons/SmartPhone2SVG.tsx

var SmartPhoneSvg = function(param) {
    var _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_4422_18412)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.2857 1.5H3.71429C2.76751 1.5 2 2.1268 2 2.9V14.1C2 14.8732 2.76751 15.5 3.71429 15.5H12.2857C13.2325 15.5 14 14.8732 14 14.1V2.9C14 2.1268 13.2325 1.5 12.2857 1.5Z",
                        stroke: isActive ? "#00ab6b" : "#333333",
                        strokeWidth: isActive ? "1.5" : "1",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8 12.5H8.00667",
                        stroke: isActive ? "#00ab6b" : "#333333",
                        strokeWidth: isActive ? "2" : "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4422_18412",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var SmartPhone2SVG = (SmartPhoneSvg);

;// CONCATENATED MODULE: ./src/features/edit-profile/constants.ts

var MAX_IMG_SIZE = 2097152; // +-2MB
var ACCEPTED_IMG_EXTENSIONS = [
    ".jpg",
    ".jpeg",
    ".png"
];
var DEFAULT_AVATAR = "https://avatar.stockbit.com/placeholders/S.png";
var NAVIGATION_ITEMS = [
    {
        label: "Public Profile",
        value: "public-profile",
        icon: "icon-securities_account_publicprofile",
        url: "/account"
    },
    {
        label: "Preferences",
        value: "preferences",
        icon: "icon-profile_location",
        url: "/preferences"
    },
    {
        label: "Password",
        value: "password",
        icon: "icon-securities-lock",
        url: "/password"
    },
    {
        label: "Notification",
        value: "notification",
        icon: "icon-toolbar_bell",
        url: "/notification"
    },
    {
        label: "Link Account",
        value: "link-account",
        icon: "icon-link-chain",
        url: "/integration"
    },
    {
        label: "Privacy",
        value: "privacy",
        icon: "icon-user-privacy",
        url: "/privacy"
    },
    {
        label: "Linked Devices",
        value: "linked-devices",
        icon: "icon-user-privacy",
        url: "/linked-devices",
        iconSVG: SmartPhone2SVG
    },
    {
        label: "Share Trade",
        value: "sharetrade",
        icon: "icon-sync-contact",
        url: "/sharetrade"
    },
    {
        label: "Blocked List",
        value: "blocked-list",
        icon: "icon-user-block",
        url: "/blocked"
    },
    {
        label: "Delete Account",
        value: "delete-account",
        icon: "icon-cancel_circle",
        url: "/delete"
    }, 
];
var INDONESIA_CITY_LIST = [
    "Aceh",
    "Ambon",
    "Banjarmasin",
    "Bali",
    "Bandar Lampung",
    "Banten",
    "Bengkulu",
    "Gorontalo",
    "Jambi",
    "Jayapura",
    "Kendari",
    "Kupang",
    "Makassar",
    "Mamuju",
    "Manado",
    "Manokwari",
    "Mataram",
    "Padang",
    "Palangkaraya",
    "Palembang",
    "Palu",
    "Pangkal Pinang",
    "Pekanbaru",
    "Pontianak",
    "Samarinda",
    "Semarang",
    "Sofifi",
    "Tanjung Pinang",
    "Tanjung Selor", 
];
var INDONESIA_PREFERRED_CITY_LIST = [
    "DKI Jakarta",
    "Surabaya",
    "Bandung",
    "Yogyakarta", 
];
var MONTHS = (/* unused pure expression or super */ null && ([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December", 
]));
var SUCCESS_CONTENT = {
    PASSWORD: "Password Sudah Diubah",
    EMAIL: "Email Kamu Sudah Diubah",
    PHONE: "Nomor Hp Kamu Sudah Diubah"
};
var PROGRESS_STATUS_ENUM = {
    no_amend: 1,
    verification: 2,
    in_progress: 3,
    rejected: 4
};
var WORDING_FORMAT_EMAIL_WRONG = "Email yang kamu masukkan tidak valid";
var SHARE_TRADE_PREVIEW = {
    text: "Order Buy TLKM",
    symbol: "TLKM",
    order_type: "ORDER_TYPE_BUY",
    status: "ORDER_STATUS_OPEN",
    updated_status: "UPDATED_STATUS_UNSPECIFIED",
    price: "Rp3,930",
    updated_price: "",
    parent_order_id: "XL1205922VspdLUJrOr7",
    order_time: "2024-06-13T02:30:00Z",
    label: "LABEL_UNSPECIFIED",
    is_show_value: false,
    qty: 0,
    updated_qty: 0,
    total_investment: "Rp3,930,000",
    is_amend_lot: false
};



/***/ }),

/***/ 1473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oD": function() { return /* binding */ getPreviewData; },
  "h3": function() { return /* binding */ getRemapOrderAction; },
  "o8": function() { return /* binding */ getRemapOrderStatus; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/typings/api/shareTradeShare.ts
var shareTradeShare = __webpack_require__(10529);
// EXTERNAL MODULE: ./src/features/edit-profile/constants.ts + 1 modules
var constants = __webpack_require__(8112);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
;// CONCATENATED MODULE: ./src/features/sharetrade/constants/shareTradeOrder.ts



var _obj;
var orderStatusRemap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* OrderStatus.Open */.iF.Open, shareTradeShare/* ShareOrderStatus.Open */.F.Open), (0,_define_property/* default */.Z)(_obj, transaction/* OrderStatus.Amended */.iF.Amended, shareTradeShare/* ShareOrderStatus.Amend */.F.Amend), (0,_define_property/* default */.Z)(_obj, transaction/* OrderStatus.Match */.iF.Match, shareTradeShare/* ShareOrderStatus.Match */.F.Match), (0,_define_property/* default */.Z)(_obj, transaction/* OrderStatus.Withdrawn */.iF.Withdrawn, shareTradeShare/* ShareOrderStatus.Cancel */.F.Cancel), _obj);
var _obj1;
var orderActionRemap = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, transaction/* OrderAction.Buy */.iX.Buy, shareTradeShare/* ShareOrderType.Buy */.y.Buy), (0,_define_property/* default */.Z)(_obj1, transaction/* OrderAction.Sell */.iX.Sell, shareTradeShare/* ShareOrderType.Sell */.y.Sell), _obj1);

;// CONCATENATED MODULE: ./src/features/sharetrade/utils/shareTradeOrder.ts






var getRemapOrderStatus = function(status) {
    return orderStatusRemap[status] || shareTradeShare/* ShareOrderStatus.Unspecified */.F.Unspecified;
};
var getRemapOrderAction = function(action) {
    return orderActionRemap[action] || shareTradeShare/* ShareOrderType.Unspecified */.y.Unspecified;
};
var getPreviewData = function(transactionData) {
    var ref = transactionData || {}, symbol = ref.symbol, status = ref.status, type = ref.type, price = ref.price, total_investment = ref.total_investment, order_time = ref.order_time;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* SHARE_TRADE_PREVIEW */._T), {
        symbol: symbol,
        status: status,
        order_time: order_time,
        order_type: type,
        text: "Order ".concat(type === "ORDER_TYPE_BUY" ? "Buy" : "Sell", " ").concat(symbol),
        price: "Rp ".concat((0,number/* formatNumber */.uf)(price)),
        total_investment: "Rp ".concat((0,number/* formatNumber */.uf)(total_investment))
    });
};


/***/ }),

/***/ 7035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fq": function() { return /* binding */ NonSyariahBadgeLabel; },
/* harmony export */   "JL": function() { return /* binding */ NonSyariahBannerDescription; },
/* harmony export */   "f8": function() { return /* binding */ NonSyariahBannerWrapper; },
/* harmony export */   "lK": function() { return /* binding */ NonSyariahBadgeWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: #fdeded;\n  gap: 16px;\n  border-radius: 4px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 18px;\n\n  span {\n    font-weight: 700;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  border: 1px solid #fdeded;\n  border-radius: 2px;\n  background: #fdeded;\n  padding: 3px 5px;\n  margin-left: 7px;\n  text-wrap: nowrap;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var NonSyariahBannerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fb19d31c-0"
})(_templateObject());
var NonSyariahBannerDescription = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    size: "14px",
    color: "#333333"
}).withConfig({
    componentId: "sc-fb19d31c-1"
})(_templateObject1());
var NonSyariahBadgeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fb19d31c-2"
})(_templateObject2(), function(param) {
    var noMargin = param.noMargin;
    return noMargin && "\n    margin: 0px;\n  ";
});
var NonSyariahBadgeLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    family: "bold",
    color: "#EE4A49",
    size: "8px"
}).withConfig({
    componentId: "sc-fb19d31c-3"
})(_templateObject3());


/***/ }),

/***/ 11322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NonSyariahBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7035);


function NonSyariahBadge(param) {
    var label = param.label, noMargin = param.noMargin;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styled__WEBPACK_IMPORTED_MODULE_1__/* .NonSyariahBadgeWrapper */ .lK, {
        noMargin: noMargin,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styled__WEBPACK_IMPORTED_MODULE_1__/* .NonSyariahBadgeLabel */ .Fq, {
            children: label
        })
    });
};


/***/ }),

/***/ 22067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NonSyariahBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(579);
/* harmony import */ var _components_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7035);



function NonSyariahBanner(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_styled__WEBPACK_IMPORTED_MODULE_2__/* .NonSyariahBannerWrapper */ .f8, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                src: "/images/syariah/info-danger.svg",
                alt: "Info",
                height: "18",
                width: "18"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styled__WEBPACK_IMPORTED_MODULE_2__/* .NonSyariahBannerDescription */ .JL, {
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 8587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OrderTable_OrderDetailModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/features/day-trade/components/Banner.tsx
var Banner = __webpack_require__(76431);
// EXTERNAL MODULE: ./src/features/sharetrade/analytics/shareTradeShareTracker.ts
var shareTradeShareTracker = __webpack_require__(56371);
// EXTERNAL MODULE: ./src/features/sharetrade/stores/useShareTradeModal.ts
var useShareTradeModal = __webpack_require__(77064);
// EXTERNAL MODULE: ./src/features/sharetrade/utils/shareTradeOrder.ts + 1 modules
var shareTradeOrder = __webpack_require__(1473);
// EXTERNAL MODULE: ./src/features/syariah/components/NonSyariahBanner.tsx
var NonSyariahBanner = __webpack_require__(22067);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/Securities/constants/transactionForm.ts
var transactionForm = __webpack_require__(9657);
// EXTERNAL MODULE: ./src/global/Securities/stores/useEmittenInfoStore.ts + 1 modules
var useEmittenInfoStore = __webpack_require__(97454);
// EXTERNAL MODULE: ./src/global/Securities/types/stockType.ts
var stockType = __webpack_require__(56644);
// EXTERNAL MODULE: ./src/global/Securities/types/store/order.ts
var order = __webpack_require__(91037);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
// EXTERNAL MODULE: ./src/global/Securities/utils/formula.ts
var formula = __webpack_require__(98202);
// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
// EXTERNAL MODULE: ./src/global/TradingModal/hooks/useIsUserSyariah.ts + 1 modules
var useIsUserSyariah = __webpack_require__(66940);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Securities/stores/useOrderDetailStore.ts
var useOrderDetailStore = __webpack_require__(87127);
;// CONCATENATED MODULE: ./src/hooks/useCalculateRealized.ts


function useCalculateRealized(symbol, amountMatchedTotal, qtyLotDone) {
    var orderDetail = (0,useOrderDetailStore/* default */.Z)(function(s) {
        return s.data;
    });
    var portfolioAvgPrice = orderDetail === null || orderDetail === void 0 ? void 0 : orderDetail.price_average_portfolio;
    var showRealized = (0,react.useMemo)(function() {
        return portfolioAvgPrice && qtyLotDone !== 0 && amountMatchedTotal / qtyLotDone !== 0;
    }, [
        portfolioAvgPrice,
        qtyLotDone,
        amountMatchedTotal
    ]);
    // Realized Gain / Loss
    var totalRealized = (0,react.useMemo)(function() {
        return amountMatchedTotal - portfolioAvgPrice * (qtyLotDone * 100);
    }, [
        portfolioAvgPrice,
        qtyLotDone,
        amountMatchedTotal
    ]);
    var realizedPercentage = (0,react.useMemo)(function() {
        return Math.abs((amountMatchedTotal - portfolioAvgPrice * (qtyLotDone * 100)) / (portfolioAvgPrice * (qtyLotDone * 100)));
    }, [
        portfolioAvgPrice,
        qtyLotDone,
        amountMatchedTotal
    ]);
    var isLoss = (0,react.useMemo)(function() {
        return totalRealized < 0;
    }, [
        totalRealized
    ]);
    return {
        showRealized: showRealized,
        isLoss: isLoss,
        totalRealized: totalRealized,
        realizedPercentage: realizedPercentage
    };
};

// EXTERNAL MODULE: ./src/hooks/useGetPortfolioData.ts
var useGetPortfolioData = __webpack_require__(47002);
// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/lib/analytics/autoOrder.ts
var autoOrder = __webpack_require__(66959);
// EXTERNAL MODULE: ./src/lib/analytics/securities.ts
var securities = __webpack_require__(91154);
// EXTERNAL MODULE: ./src/lib/analytics/virtualTrading.ts
var virtualTrading = __webpack_require__(29351);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/stores/sharetrade/useShareTradeShare.ts
var useShareTradeShare = __webpack_require__(75774);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/Securities/types/trading.ts
var types_trading = __webpack_require__(6421);
// EXTERNAL MODULE: ./src/features/trade/components/DetailModal/index.tsx + 3 modules
var DetailModal = __webpack_require__(4303);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
;// CONCATENATED MODULE: ./src/features/trade/components/OrderTable/Realized.tsx





function Realized(param) {
    var _total = param.total, total = _total === void 0 ? 0 : _total, _percentage = param.percentage, percentage = _percentage === void 0 ? 0 : _percentage, _isLoss = param.isLoss, isLoss = _isLoss === void 0 ? false : _isLoss;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
        color: (0,general/* getColorBasedOnNumber */.pV)(total),
        family: "bold",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    isLoss ? "" : "+",
                    (0,number/* formatNumber */.uf)(total, false, "0,00", true)
                ]
            }),
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    "(",
                    isLoss ? "-" : "+",
                    numeral_default()(percentage * 100).format("0,00.00", Math.floor),
                    "%)"
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/styled.ts
var styled = __webpack_require__(56416);
// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/useOrderDetailAction.ts
var useOrderDetailAction = __webpack_require__(53081);
// EXTERNAL MODULE: ./src/features/trade/components/styled.ts
var components_styled = __webpack_require__(94514);
;// CONCATENATED MODULE: ./src/features/trade/components/OrderTable/OrderDetailModal.tsx






































var formatDate = function(date) {
    return moment_default()(date).format("DD MMM YY HH:mm:ss");
};
var Prefix = function(param) {
    var status = param.status, message = param.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
        condition: status === "REJECTED",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* RejectedBox */.nC, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "p",
                    family: "bold",
                    children: "Order Rejected"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: message
                })
            ]
        })
    });
};
var OrderDetailModal = function(param) {
    var data = param.data, visible = param.visible, onCancel = param.onCancel, onCancelOrder = param.onCancelOrder;
    var ref;
    var action = data.action, symbol = data.symbol, order_total = data.order_total, price = data.price, status = data.status, gtc = data.gtc, label = data.label, config_type = data.config_type, trigger_price = data.trigger_price, amount_invested_fee = data.amount_invested_fee, market_orderid = data.market_orderid, time_open = data.time_open, message = data.message, orderid = data.orderid, day_trade_is_day_trade = data.day_trade_is_day_trade, day_trade_force_sell_event = data.day_trade_force_sell_event, isStockSyariah = data.is_sharia, trailing_stop = data.trailing_stop, platform_order_type = data.platform_order_type;
    var handleAmendOrderClick = (0,useOrderDetailAction/* default */.Z)({
        data: data,
        onCancel: onCancel
    }).handleAmendOrderClick;
    var isDayTrade = day_trade_is_day_trade;
    var isMarketOrder = platform_order_type === order/* PlatformOrderTypes.FAK */.F4.FAK;
    var isLitSell = label === types_trading/* SmartOrderLabel.LIT_SELL */.D0.LIT_SELL;
    var portfolio = (0,tradingData/* default */.Z)(function(s) {
        return {
            portfolio: s.portfolio
        };
    }, shallow/* default */.Z).portfolio;
    var tradingbalance = portfolio.data.tradingbalance;
    var portfolioData = (0,useGetPortfolioData/* default */.Z)(symbol, true, false, isDayTrade);
    var isRealTrading = (0,useTradingAccount/* default */.Z)().isRealTrading;
    var isUserSyariah = (0,useIsUserSyariah/* default */.Z)();
    var emittenInfo = (0,useEmittenInfoStore/* default */.Z)(function(s) {
        return s.data;
    });
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.isVisible,
            s.setIsVisible,
            s.setSharedUsers,
            s.resetShareTradeModal, 
        ];
    }, shallow/* default */.Z), 4), isShareTradeVisible = ref1[0], setIsShareTradeVisible = ref1[1], setSharedUsers = ref1[2], resetShareTradeModal = ref1[3];
    var setTransactionData = (0,useShareTradeShare/* default */.Z)(function(s) {
        return s.setTransactionData;
    }, shallow/* default */.Z);
    var isDetaillVisible = (0,react.useMemo)(function() {
        return visible && !isShareTradeVisible;
    }, [
        visible,
        isShareTradeVisible
    ]);
    var isShowShareButton = (0,react.useMemo)(function() {
        return data.status === transaction/* OrderStatus.Match */.iF.Match;
    }, [
        data.status
    ]);
    // Realized Gain / Loss
    var ref2 = useCalculateRealized(symbol, data.amount_matched_total, data.order_done), totalRealized = ref2.totalRealized, isLoss = ref2.isLoss, realizedPercentage = ref2.realizedPercentage, showRealized = ref2.showRealized;
    var handleShareTradeClick = function() {
        var ref;
        var sharesQty = order_total * constant/* lotSize */.CQ;
        setTransactionData({
            order_id: orderid,
            price: price,
            symbol: symbol,
            status: (0,shareTradeOrder/* getRemapOrderStatus */.o8)(data.status),
            type: (0,shareTradeOrder/* getRemapOrderAction */.h3)(data.action),
            order_time: new Date("".concat(data.time_match.replace(" ", "T"), "Z")).toISOString(),
            qty: sharesQty,
            total_investment: price * sharesQty
        });
        (0,shareTradeShareTracker/* trackOrderDetailShareSelected */.DN)(action, orderid, symbol, (ref = emittenInfo.type_company) === null || ref === void 0 ? void 0 : ref.toLowerCase(), transactionForm/* expiryTypeById */.wc[gtc], message, status);
        setIsShareTradeVisible(true);
    };
    var handleModalCancel = function() {
        resetShareTradeModal();
        setSharedUsers({});
        onCancel();
    };
    (0,react.useEffect)(function() {
        if (data) {
            if (isRealTrading) {
                (0,securities/* clevertapOrderDetailViewed */.kt)({
                    status: status,
                    orderType: action,
                    rejectReason: message,
                    expiry: Number(gtc) === 1 ? virtualTrading/* ORDER_EXPIRY.goodTillCanceled */.Y0.goodTillCanceled : virtualTrading/* ORDER_EXPIRY.goodForDay */.Y0.goodForDay,
                    symbol: symbol,
                    type: virtualTrading/* VIRTUAL_TRADING_TYPES.realTrading */.gT.realTrading,
                    dayTrade: isDayTrade,
                    dayTradeForceSell: !!order/* ForcedSellMapper */.l5[day_trade_force_sell_event]
                });
            }
            (0,autoOrder/* trackAutoBuyDetailView */.Fs)();
        }
    }, [
        data
    ]);
    var generatePorfolioInfo = function() {
        var buyLabel = isDayTrade ? "In My Day Trade" : "In My Portfolio";
        var portfolioInfo = [
            {
                key: "title",
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    children: buyLabel
                }),
                value: ""
            },
            {
                key: "tradingBalance",
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: "Trading Balance"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "right",
                    children: (0,number/* formatNumber */.uf)(tradingbalance)
                })
            }, 
        ];
        if (action === trading/* ORDER_TYPE.SELL */.Jm.SELL) {
            var ref;
            portfolioInfo[1] = {
                key: "availableLot",
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    children: [
                        "Available lot in",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                fontWeight: "bold"
                            },
                            children: symbol
                        })
                    ]
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "right",
                    weight: "bold",
                    children: (ref = portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.available_lot) !== null && ref !== void 0 ? ref : 0
                })
            };
        }
        return portfolioInfo;
    };
    var generateTitleBasedOnOrder = function(key, orderType) {
        var addPrefix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var prefix = addPrefix && (isMarketOrder || trailing_stop) ? "Estimated " : "";
        var keyByOrder = {
            investmentDone: {
                buy: "Investment",
                sell: "Proceeds"
            },
            investmentFeeDone: {
                buy: "Investment (Plus Fee)",
                sell: "Proceeds (Net Fee)"
            },
            investmentFeeInfo: {
                buy: "Investment (Plus Fee)",
                sell: "Proceeds (Net Fee)"
            }
        };
        return prefix + (keyByOrder[key] ? keyByOrder[key][orderType] : "");
    };
    var expiry = Number(gtc) !== 0 ? trading/* ORDER_EXPIRY_TEXT.gtc */.cD.gtc : trading/* ORDER_EXPIRY_TEXT.gfd */.cD.gfd;
    var displayedPrice = (0,number/* formatNumber */.uf)(price);
    var getEstimationFee = function() {
        if (trailing_stop) {
            return (0,number/* formatNumber */.uf)((0,formula/* getSellAmountInvestedFee */.B1)(order_total, price, [
                stockType/* StockType.Waran */.Z.Waran,
                stockType/* StockType.Right */.Z.Right,
                stockType/* StockType.Etf */.Z.Etf
            ].includes(emittenInfo.type_company), day_trade_is_day_trade));
        }
        return (0,number/* formatNumber */.uf)(amount_invested_fee, true, amount_invested_fee % 1 === 0 ? "0,0" : "0,0.00");
    };
    var estimation = getEstimationFee();
    if (isMarketOrder) {
        expiry = "Fill and Kill";
        displayedPrice = "Market";
        if (!amount_invested_fee || amount_invested_fee === 0) estimation = "-";
    }
    var orderInfo = [
        {
            key: "status",
            label: "Status",
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: trading/* ORDER_STATUS_COLOR.order */.PX.order[status.toLowerCase()],
                align: "right",
                family: "bold",
                children: status
            })
        },
        {
            key: "expiry",
            label: "Expiry",
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: expiry
            })
        }, 
    ];
    if (status === "READY" && label === "AB") {
        orderInfo = (0,_to_consumable_array/* default */.Z)(orderInfo).concat([
            {
                key: "triggerPrice",
                label: "Trigger Price",
                value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    align: "right",
                    children: [
                        config_type === "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "≥"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "≤"
                        }),
                        " ",
                        (0,number/* formatNumber */.uf)(trigger_price)
                    ]
                })
            }, 
        ]);
    }
    orderInfo = (0,_to_consumable_array/* default */.Z)(orderInfo).concat([
        {
            key: "price",
            label: "Price",
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: displayedPrice
            })
        },
        {
            key: "lot",
            label: "Lot",
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: order_total
            })
        }, 
    ], (0,_to_consumable_array/* default */.Z)(trailing_stop ? [
        {
            key: "trailPercentage",
            label: "Trail Percentage",
            value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                align: "right",
                children: [
                    numeral_default()(trailing_stop === null || trailing_stop === void 0 ? void 0 : (ref = trailing_stop.price_algorithm) === null || ref === void 0 ? void 0 : ref.value).format("0,0.00"),
                    "%"
                ]
            })
        },
        {
            key: "stopPrice",
            label: "Stop Price",
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: numeral_default()(trailing_stop === null || trailing_stop === void 0 ? void 0 : trailing_stop.stop_price.units).format("0,0")
            })
        }, 
    ] : []), [
        {
            key: "investmentFeeInfo",
            label: generateTitleBasedOnOrder("investmentFeeInfo", action.toLowerCase(), true),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                weight: "bold",
                children: estimation
            })
        },
        {
            key: "idxOrderId",
            label: "IDX Order ID",
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: market_orderid !== null && market_orderid !== void 0 ? market_orderid : "-"
            })
        },
        {
            key: "orderTime",
            label: "Order Time",
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: time_open ? formatDate(time_open) : "-"
            })
        }, 
    ]);
    var generateOrderDone = function(key, param) {
        var _price_average = param.price_average, price_average = _price_average === void 0 ? 0 : _price_average, _order_done = param.order_done, order_done = _order_done === void 0 ? 0 : _order_done, _amount_matched = param.amount_matched, amount_matched = _amount_matched === void 0 ? 0 : _amount_matched, _amount_matched_broker_fee = param.amount_matched_broker_fee, amount_matched_broker_fee = _amount_matched_broker_fee === void 0 ? 0 : _amount_matched_broker_fee, _amount_matched_exchange_fee = param.amount_matched_exchange_fee, amount_matched_exchange_fee = _amount_matched_exchange_fee === void 0 ? 0 : _amount_matched_exchange_fee, _amount_matched_total = param.amount_matched_total, amount_matched_total = _amount_matched_total === void 0 ? 0 : _amount_matched_total;
        var config = {
            price: (0,number/* formatNumber */.uf)(price_average, false, (0,number/* isFloat */.Q7)(price_average) ? "0,0.00" : "0,0"),
            lot: order_done,
            investmentDone: (0,number/* formatNumber */.uf)(amount_matched),
            brokerFee: (0,number/* formatNumber */.uf)(amount_matched_broker_fee, true, "0,0.00"),
            exchangeFee: (0,number/* formatNumber */.uf)(amount_matched_exchange_fee, true, "0,0.00"),
            infestmentFeeDone: (0,number/* formatNumber */.uf)(amount_matched_total, true, "0,0.00")
        };
        if (config[key] === undefined || Number(config[key]) === 0) {
            return "-";
        }
        return config[key];
    };
    var orderDone = [
        {
            key: "price",
            label: "Price",
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: generateOrderDone("price", data)
            })
        },
        {
            key: "lot",
            label: "Lot",
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: generateOrderDone("lot", data)
            })
        },
        {
            key: "investmentDone",
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: generateTitleBasedOnOrder("investmentDone", action.toLowerCase())
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: generateOrderDone("investmentDone", data)
            })
        },
        {
            key: "brokerFee",
            label: "Broker Fee",
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: generateOrderDone("brokerFee", data)
            })
        },
        {
            key: "exchangeFee",
            label: "Exchange Fee",
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: generateOrderDone("exchangeFee", data)
            })
        },
        {
            key: "infestmentFeeDone",
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: generateTitleBasedOnOrder("investmentFeeDone", action.toLowerCase())
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: generateOrderDone("infestmentFeeDone", data)
            })
        }, 
    ];
    if (showRealized && action === trading/* ORDER_TYPE.SELL */.Jm.SELL) {
        orderDone.push({
            key: "realized",
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                family: "bold",
                children: [
                    "Realized ",
                    isLoss ? "Loss" : "Gain"
                ]
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Realized, {
                total: totalRealized,
                percentage: realizedPercentage,
                isLoss: isLoss
            })
        });
    }
    var showNonSyariahBanner = (0,react.useMemo)(function() {
        return isUserSyariah && !isStockSyariah && action === trading/* ORDER_TYPE.BUY */.Jm.BUY && ![
            transaction/* OrderStatus.Rejected */.iF.Rejected,
            transaction/* OrderStatus.Withdrawn */.iF.Withdrawn
        ].includes(status);
    }, [
        isUserSyariah,
        isStockSyariah,
        action,
        status
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailModal/* default */.Z, {
        visible: isDetaillVisible,
        onCancel: handleModalCancel,
        title: "".concat(action, " ").concat(symbol),
        symbol: symbol,
        prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(Prefix, {
            status: status,
            message: message
        }),
        suffix: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styled/* ModalButtonContainerSecondary */.c7, {
            children: [
                (data === null || data === void 0 ? void 0 : data.cancel_action) && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* DetailOrderButton */.VT, {
                    variant: "cancel",
                    onClick: onCancelOrder,
                    children: "Cancel Order"
                }),
                (data === null || data === void 0 ? void 0 : data.amend_action) && !isLitSell && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* DetailOrderButton */.VT, {
                    variant: "amend",
                    onClick: handleAmendOrderClick,
                    children: "Amend"
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isDayTrade,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* default */.Z, {
                    label: day_trade_force_sell_event,
                    timeOpen: time_open
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: showNonSyariahBanner,
                children: status === transaction/* OrderStatus.Match */.iF.Match ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonSyariahBanner/* default */.Z, {
                    children: [
                        "Saham telah keluar dari ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Daftar Efek Syariah"
                        }),
                        ". Segera Jual saham tersebut dari portfolio kamu."
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonSyariahBanner/* default */.Z, {
                    children: [
                        "Saham yang kamu order sudah keluar dari",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Daftar Efek Syariah."
                        }),
                        " Silakan batalkan order kamu."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* OrderModalInfoTable */.Xt, {
                dataSource: orderInfo,
                title: "".concat(action.toLowerCase(), " Order")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* OrderModalInfoTable */.Xt, {
                dataSource: orderDone,
                title: "".concat(action.toLowerCase(), " Done")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* OrderModalInfoTable */.Xt, {
                dataSource: generatePorfolioInfo()
            }),
            isShowShareButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ShareTradeButton */.Ae, {
                type: "primary",
                onClick: handleShareTradeClick,
                block: true,
                children: "Share Trade"
            })
        ]
    });
};
/* harmony default export */ var OrderTable_OrderDetailModal = (OrderDetailModal);


/***/ }),

/***/ 56416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AF": function() { return /* binding */ FilterActionWrapper; },
/* harmony export */   "Ae": function() { return /* binding */ ShareTradeButton; },
/* harmony export */   "Gz": function() { return /* binding */ FilterAction; },
/* harmony export */   "Kk": function() { return /* binding */ ActionButton; },
/* harmony export */   "Lb": function() { return /* binding */ FilterButton; },
/* harmony export */   "NR": function() { return /* binding */ AutoOrderBadge; },
/* harmony export */   "Pz": function() { return /* binding */ HeaderWrapper; },
/* harmony export */   "Ux": function() { return /* binding */ FilterTitle; },
/* harmony export */   "VT": function() { return /* binding */ DetailOrderButton; },
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "Xt": function() { return /* binding */ OrderModalInfoTable; },
/* harmony export */   "gU": function() { return /* binding */ OverlayDropdown; },
/* harmony export */   "iz": function() { return /* binding */ Divider; },
/* harmony export */   "kI": function() { return /* binding */ FilterWrapper; },
/* harmony export */   "nC": function() { return /* binding */ RejectedBox; },
/* harmony export */   "vn": function() { return /* binding */ OrderTable; }
/* harmony export */ });
/* unused harmony export FooterActionWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79931);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27049);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71577);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81190);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19521);
/* harmony import */ var _DetailModal_InfoTable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51981);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  min-height: 60px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 1250px;\n  cursor: pointer;\n\n  table {\n    border-collapse: collapse;\n  }\n\n  .ant-table-thead > tr {\n    height: 50px;\n\n    & > th {\n      padding: 0 8px;\n      height: 17px;\n      font-size: 14px;\n      border-top: 1px solid ",
        ";\n      border-bottom: 1px solid ",
        ";\n\n      &:first-child {\n        padding-left: 16px;\n      }\n      &:last-child {\n        padding-right: 16px;\n      }\n\n      .ant-table-selection {\n        display: flex;\n      }\n    }\n  }\n\n  .ant-checkbox-wrapper {\n    vertical-align: middle;\n\n    .ant-checkbox-indeterminate > .ant-checkbox-inner {\n      border: 1px solid #00ab6b;\n      background-color: #00ab6b;\n\n      :after {\n        background-color: #ffffff;\n        height: 2px;\n        border-radius: 1px;\n      }\n    }\n  }\n\n  .ant-empty-description {\n    font-size: 12px;\n    font-family: var(--regular-font);\n    color: #0000006e;\n  }\n\n  .ant-btn[disabled] {\n    background: white;\n  }\n\n  .ant-table-thead > tr > th {\n    font-size: 14px;\n    border-top: 1px solid ",
        ";\n    border-bottom: 1px solid ",
        ";\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td:not(.td-mobile) {\n    display: none;\n  }\n\n  .ant-table-content {\n    overflow-x: auto;\n  }\n\n  .ant-table-tbody > tr {\n    height: 48px;\n\n    & > td {\n      padding: 0 8px;\n      border-bottom: 0;\n\n      &:first-child {\n        padding-left: 16px;\n      }\n\n      &:last-child {\n        padding-right: 16px;\n      }\n    }\n  }\n\n  .ant-table-tbody > tr > .td-mobile:first-child {\n    display: block;\n    width: 100vw;\n    border-width: 0;\n    height: 25px;\n  }\n\n  /* Invested column */\n  .ant-table-tbody > tr > td:nth-child(6) {\n    text-align: left !important;\n  }\n  /* Action column */\n  .ant-table-tbody > tr > td:last-child > div {\n    height: 37px;\n  }\n\n  .ant-table-tbody > tr > .td-mobile {\n    display: inline-block;\n    width: calc(100vw / 4);\n  }\n\n  ",
        " {\n    display: block;\n  }\n\n  @media ",
        " {\n    .ant-table-thead > tr > th,\n    .ant-table-tbody > tr > td:not(.td-mobile) {\n      display: table-cell;\n    }\n\n    .ant-table-content {\n      overflow-x: auto;\n    }\n\n    .ant-table-tbody > tr > .td-mobile:first-child,\n    .ant-table-tbody > tr > .td-mobile {\n      display: table-cell;\n      width: inherit;\n      border-width: 1px;\n    }\n\n    /* Invested column */\n    .ant-table-tbody > tr > td:nth-child(6) {\n      text-align: right !important;\n    }\n    /* Action column */\n    .ant-table-tbody > tr > td:last-child > div {\n      height: unset;\n    }\n\n    & .ant-checkbox-wrapper {\n      align-items: center;\n      padding: 3px;\n\n      & > .ant-checkbox {\n        top: 0;\n\n        & > .ant-checkbox-inner {\n          width: 18px;\n          height: 18px;\n          border-radius: 4px;\n        }\n      }\n\n      & > .ant-checkbox-checked::after {\n        border-radius: 4px;\n      }\n\n      & > span:nth-child(2) {\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 16px;\n      }\n    }\n\n    ",
        " {\n      display: none;\n    }\n  }\n\n  .ant-pagination {\n    background: ",
        ";\n    margin: 0px;\n    padding: 16px 0 12px 20px;\n\n    .ant-pagination-item,\n    .ant-pagination-jump-prev,\n    .ant-pagination-jump-next {\n      display: none;\n    }\n    .ant-pagination-item-link {\n      height: 24px;\n      border-radius: 0;\n      padding: 0 8px;\n      font-family: var(--regular-font);\n      line-height: 100%;\n      font-size: 12px;\n      &.next-button {\n        margin-left: -1px;\n      }\n\n      &:not([disabled]) {\n        color: ",
        ";\n      }\n\n      &:hover:not([disabled]) {\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: normal;\n  height: unset;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  padding: 18px 18px 20px;\n  border: 1px solid #ff525244;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid #ededed;\n  border-radius: 2px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  width: 100%;\n  height: 36px;\n  align-items: center;\n  margin-left: 0px !important;\n  padding: 0 20px;\n\n  span {\n    padding: 0;\n  }\n\n  :hover {\n    background: #f7f7f7;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 200px;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  margin-top: 5px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 280px;\n  overflow-y: scroll;\n  padding: 10px 0;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 36px;\n  height: 36px;\n  padding: 0 20px;\n  text-align: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 90px;\n  height: 35px;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  margin: 0 0 0 16px;\n  ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 78px;\n  height: 28px;\n  border-radius: 4px;\n  font-weight: 700;\n\n  ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n  justify-content: space-between;\n  align-items: center;\n  height: 53px;\n  padding: 0 16px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 16px 0 10px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 46px;\n  color: #ffffff;\n  border-radius: 4px;\n\n  font-size: 18px;\n  font-weight: 700;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border-color: #00ab6b;\n    color: #00ab6b;\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border-color: #ee4a49;\n    color: #ee4a49;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  border: 1px solid;\n  background-color: transparent;\n\n  font-size: 14px;\n  line-height: 19px;\n  font-weight: 700;\n\n  border-radius: 4px;\n  padding: 12px;\n  min-height: 44px;\n\n  cursor: pointer;\n  opacity: 1;\n  transition: opacity 0.15s ease-out;\n\n  &:hover {\n    opacity: 0.7;\n  }\n\n  &:active {\n    opacity: 1;\n  }\n\n  ",
        ";\n\n  &:disabled {\n    border: 1px solid #ccc;\n    color: #ccc;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}









var CellLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].midgray */ .Z.midgray,
    size: "12px",
    align: "inherit"
}).withConfig({
    componentId: "sc-e77d6494-0"
})(_templateObject());
var HeaderWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e77d6494-1"
})(_templateObject1());
var OrderTable = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e77d6494-2"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, CellLabel, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].mobileL */ .Z.mobileL, CellLabel, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var ActionButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e77d6494-3"
})(_templateObject3());
var RejectedBox = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e77d6494-4"
})(_templateObject4());
var AutoOrderBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    p: "3px 5px",
    family: "bold",
    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highgray */ .Z.highgray,
    size: "8px",
    ml: "10px"
}).withConfig({
    componentId: "sc-e77d6494-5"
})(_templateObject5());
var OrderModalInfoTable = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_DetailModal_InfoTable__WEBPACK_IMPORTED_MODULE_7__/* .InfoTable */ .C).withConfig({
    componentId: "sc-e77d6494-6"
})(_templateObject6());
var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e77d6494-7"
})(_templateObject7());
var OverlayDropdown = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e77d6494-8"
})(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].downgray */ .Z.downgray);
var FilterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e77d6494-9"
})(_templateObject9());
var FilterTitle = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].b.withConfig */ .ZP.b.withConfig({
    componentId: "sc-e77d6494-10"
})(_templateObject10());
var FilterButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e77d6494-11"
})(_templateObject11(), function(param) {
    var type = param.type;
    return type === "outline-primary" && "\n      color: ".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary, ";\n      border-color: ").concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary, ";\n      > p {\n        color: ").concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary, ";\n      }\n    ");
});
var FilterAction = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e77d6494-12"
})(_templateObject12(), function(param) {
    var type = param.type;
    return type === "ghost" && "\n      color: #cceee1;\n      border-color: #cceee1;\n      cursor: not-allowed;\n      :hover {\n        color: #cceee1;\n        border-color: #cceee1;\n      }\n    ";
});
var FilterActionWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e77d6494-13"
})(_templateObject13(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].downgray */ .Z.downgray);
var Divider = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e77d6494-14"
})(_templateObject14());
var ShareTradeButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e77d6494-15"
})(_templateObject15());
var FooterActionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e77d6494-16"
})(_templateObject16());
var detailOrderButtonStyles = {
    amend: (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject17()),
    cancel: (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject18())
};
var DetailOrderButton = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-e77d6494-17"
})(_templateObject19(), function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "amend" : _variant;
    return detailOrderButtonStyles[variant];
});


/***/ }),

/***/ 53081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14924);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83153);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2078);
/* harmony import */ var global_Securities_utils_maintenance__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38525);
/* harmony import */ var global_TradingModal_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70362);
/* harmony import */ var hooks_useTradingAccount__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64999);
/* harmony import */ var lib_analytics_securities__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91154);
/* harmony import */ var lib_analytics_virtualTrading__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29351);
/* harmony import */ var lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36902);
/* harmony import */ var lib_stores_tradingOperation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31532);
/* harmony import */ var utils_securities_analytics__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67600);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(60374);
/* harmony import */ var features_transaction_useTradingStore__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93918);
/* harmony import */ var global_Securities_types_autoOrder__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48453);
/* harmony import */ var global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20620);

















var _obj, _obj1;
var orderTypesToAmend = {
    real: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.BUY */ .Jm.BUY, constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.SELL */ .Jm.SELL, constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL), _obj),
    virtual: (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_obj1, constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.BUY */ .Jm.BUY, constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.VIRTUAL_AMEND_BUY */ .Jm.VIRTUAL_AMEND_BUY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_obj1, constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.SELL */ .Jm.SELL, constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.VIRTUAL_AMEND_SELL */ .Jm.VIRTUAL_AMEND_SELL), _obj1)
};
var useOrderDetailAction = function(param) {
    var data = param.data, onCancel = param.onCancel, onSubmit = param.onSubmit;
    var ref = data || {}, symbol = ref.symbol, isDayTrade = ref.day_trade_is_day_trade, trailingStop = ref.trailing_stop;
    var isRealTrading = (0,hooks_useTradingAccount__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().isRealTrading;
    var showTradingModal = (0,global_TradingModal_store__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(s) {
        return s.showModal;
    });
    var setModal = (0,features_transaction_useTradingStore__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(s) {
        return s.setModal;
    });
    var ref1 = (0,lib_stores_tradingOperation__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(s) {
        return {
            postTradeCancel: s.postTradeCancel,
            postDayTradeCancel: s.postDayTradeCancel,
            smartOrderDelete: s.smartOrderDelete,
            deleteTrailingStop: s.deleteTrailingStop
        };
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z), postTradeCancel = ref1.postTradeCancel, postDayTradeCancel = ref1.postDayTradeCancel, smartOrderDelete = ref1.smartOrderDelete, deleteTrailingStop = ref1.deleteTrailingStop;
    var ref2 = (0,lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(s) {
        return {
            getOrderHistory: s.getOrderHistory,
            getPortfolio: s.getPortfolio
        };
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z), getOrderHistory = ref2.getOrderHistory, getPortfolio = ref2.getPortfolio;
    var handleCancelOrderRequest = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (isRealTrading) {
                            (0,lib_analytics_securities__WEBPACK_IMPORTED_MODULE_6__/* .clevertapOrderDetailCancelConfirmed */ .hA)({
                                symbol: symbol,
                                orderType: data === null || data === void 0 ? void 0 : data.action,
                                expiry: (0,utils_securities_analytics__WEBPACK_IMPORTED_MODULE_10__/* .generateOrderExpiryLabel */ .d8)(data === null || data === void 0 ? void 0 : data.gtc),
                                leverage: isDayTrade ? "Day Trade" : "Regular"
                            });
                        }
                        if (!trailingStop) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 4;
                        return deleteTrailingStop(data.orderid);
                    case 4:
                        getOrderHistory(isRealTrading);
                        return _ctx.abrupt("return");
                    case 6:
                        if (!isDayTrade) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 9;
                        return postDayTradeCancel(data.orderid);
                    case 9:
                        getOrderHistory(isRealTrading);
                        return _ctx.abrupt("return");
                    case 11:
                        if (data.smart_orderid) {
                            _ctx.next = 18;
                            break;
                        }
                        _ctx.next = 14;
                        return postTradeCancel({
                            orderkey: "W-WITHDRAW-".concat(Date.now()),
                            orderid: data.orderid,
                            gtc: data.gtc,
                            symbol: symbol,
                            isRealTrading: isRealTrading
                        });
                    case 14:
                        _ctx.next = 16;
                        return getPortfolio(isRealTrading);
                    case 16:
                        _ctx.next = 20;
                        break;
                    case 18:
                        _ctx.next = 20;
                        return smartOrderDelete({
                            id: data.orderid
                        });
                    case 20:
                        getOrderHistory(isRealTrading);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCancelOrderRequest() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancelOrderClick = function(event) {
        event.stopPropagation();
        (0,global_Securities_utils_maintenance__WEBPACK_IMPORTED_MODULE_3__/* .withMaintenanceGuard */ .L)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return handleCancelOrderRequest();
                    case 2:
                        if (isRealTrading) {
                            (0,lib_analytics_securities__WEBPACK_IMPORTED_MODULE_6__/* .clevertapOrderDetailCancel */ .mf)(lib_analytics_virtualTrading__WEBPACK_IMPORTED_MODULE_7__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, symbol, data.action);
                        } else {
                            lib_analytics_virtualTrading__WEBPACK_IMPORTED_MODULE_7__/* .virtualTradingAction.onOrderDetailCancelOrderSelected */ .SP.onOrderDetailCancelOrderSelected(symbol);
                        }
                        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })));
    };
    var handleAmendOrderClick = function(event) {
        event.stopPropagation();
        (0,global_Securities_utils_maintenance__WEBPACK_IMPORTED_MODULE_3__/* .withMaintenanceGuard */ .L)(function() {
            var isAutoOrder = [
                global_Securities_types_autoOrder__WEBPACK_IMPORTED_MODULE_12__/* .AutoSellType.StopLoss */ .j.StopLoss,
                global_Securities_types_autoOrder__WEBPACK_IMPORTED_MODULE_12__/* .AutoSellType.TakeProfit */ .j.TakeProfit, 
            ].includes(data === null || data === void 0 ? void 0 : data.label);
            if (isAutoOrder) {
                setModal(global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_13__/* .MODAL_TYPE.AUTO_ORDER */ .fG.AUTO_ORDER, {
                    symbol: symbol,
                    autoOrderId: data === null || data === void 0 ? void 0 : data.orderid
                });
                onCancel();
                return;
            }
            var activeOrderTypes = isRealTrading ? orderTypesToAmend.real : orderTypesToAmend.virtual;
            var modalState = {
                symbol: symbol,
                group: data === null || data === void 0 ? void 0 : data.group,
                orderType: activeOrderTypes[data === null || data === void 0 ? void 0 : data.action],
                orderid: data.orderid,
                orderedLot: isRealTrading ? data === null || data === void 0 ? void 0 : data.order_total : data === null || data === void 0 ? void 0 : data.order_open,
                orderedPrice: Number(isRealTrading ? data === null || data === void 0 ? void 0 : data.price_order : data === null || data === void 0 ? void 0 : data.price),
                isAutoBuy: data.label === global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_2__/* .SmartOrderCode.AutoBuy */ .H1.AutoBuy && data.status === "READY",
                modalData: data,
                isDayTrade: isDayTrade,
                trailingStop: data === null || data === void 0 ? void 0 : data.trailing_stop,
                isGtc: data === null || data === void 0 ? void 0 : data.gtc
            };
            showTradingModal(modalState);
            if (isRealTrading) {
                (0,lib_analytics_securities__WEBPACK_IMPORTED_MODULE_6__/* .clevertapOrderDetailAmend */ .xA)({
                    symbol: symbol
                });
                (0,lib_analytics_securities__WEBPACK_IMPORTED_MODULE_6__/* .clevertapOrderDetailAmendViewed */ ._3)({
                    symbol: symbol,
                    orderType: data.action,
                    type: lib_analytics_virtualTrading__WEBPACK_IMPORTED_MODULE_7__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading
                });
            } else {
                lib_analytics_virtualTrading__WEBPACK_IMPORTED_MODULE_7__/* .virtualTradingNavigate.onAmendOrderViewed */ .f9.onAmendOrderViewed({
                    Symbol: symbol,
                    OrderType: data.action,
                    Type: isRealTrading ? lib_analytics_virtualTrading__WEBPACK_IMPORTED_MODULE_7__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading : lib_analytics_virtualTrading__WEBPACK_IMPORTED_MODULE_7__/* .VIRTUAL_TRADING_TYPES.virtualTrading */ .gT.virtualTrading
                });
                lib_analytics_virtualTrading__WEBPACK_IMPORTED_MODULE_7__/* .virtualTradingAction.onOrderDetailAmendSelected */ .SP.onOrderDetailAmendSelected({
                    Symbol: symbol,
                    Type: isRealTrading ? lib_analytics_virtualTrading__WEBPACK_IMPORTED_MODULE_7__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading : lib_analytics_virtualTrading__WEBPACK_IMPORTED_MODULE_7__/* .VIRTUAL_TRADING_TYPES.virtualTrading */ .gT.virtualTrading
                });
            }
            onCancel();
        });
    };
    return {
        handleAmendOrderClick: handleAmendOrderClick,
        handleCancelOrderClick: handleCancelOrderClick
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useOrderDetailAction);


/***/ }),

/***/ 38525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ withMaintenanceGuard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var instance_trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/maintenance.ts




var getMaintenanceStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,instance_trading/* getTradingApiInstance */.j)().get(apiEndpoint/* maintenanceEndpoint.getStatus */.bB.getStatus, {
                        withAccessToken: false
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getMaintenanceStatus() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/global/Securities/types/api/maintenance.ts
var MaintenanceStatusType;
(function(MaintenanceStatusType) {
    MaintenanceStatusType["Unspecified"] = "STATUS_UNSPECIFIED";
    MaintenanceStatusType["OnMaintenance"] = "STATUS_MAINTENANCE";
    MaintenanceStatusType["NotMaintenance"] = "STATUS_NOT_MAINTENANCE";
})(MaintenanceStatusType || (MaintenanceStatusType = {}));

;// CONCATENATED MODULE: ./src/global/Securities/utils/maintenance.ts





// Modify the function signature to accept arguments
function withMaintenanceGuard(// eslint-disable-next-line @typescript-eslint/ban-types
callback) {
    return _withMaintenanceGuard.apply(this, arguments);
}
function _withMaintenanceGuard() {
    _withMaintenanceGuard = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callback) {
        var isAllowed, response, _data, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    isAllowed = false;
                    if (isAllowed) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", callback());
                case 4:
                    _ctx.next = 6;
                    return getMaintenanceStatus();
                case 6:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, message = _data.message;
                    if (!(data.status === MaintenanceStatusType.OnMaintenance)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", trading/* default.getState */.Z.getState().setErrorCode(503, message, "DAILY_MAINTENANCE_MODE"));
                case 10:
                    return _ctx.abrupt("return", callback());
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", callback());
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return _withMaintenanceGuard.apply(this, arguments);
}


/***/ }),

/***/ 66940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useIsUserSyariah; }
});

// EXTERNAL MODULE: ./src/utils/securitiesLocalStorage.ts + 1 modules
var securitiesLocalStorage = __webpack_require__(11763);
;// CONCATENATED MODULE: ./src/global/Securities/types/api/auth.ts
var AccountTypeEnum;
(function(AccountTypeEnum) {
    AccountTypeEnum["EQUITY"] = "ACCOUNT_TYPE_EQUITY";
    AccountTypeEnum["SYARIAH"] = "ACCOUNT_TYPE_SYARIAH";
    AccountTypeEnum["BOND"] = "ACCOUNT_TYPE_BOND";
    AccountTypeEnum["DAY_TRADING"] = "ACCOUNT_TYPE_DAY_TRADING";
})(AccountTypeEnum || (AccountTypeEnum = {}));

;// CONCATENATED MODULE: ./src/global/TradingModal/hooks/useIsUserSyariah.ts


var useIsSyariahUser = function() {
    var accountType = securitiesLocalStorage/* default.getSecuritiesAccountInfo */.Z.getSecuritiesAccountInfo().accountType;
    return accountType === AccountTypeEnum.SYARIAH;
};
/* harmony default export */ var useIsUserSyariah = (useIsSyariahUser);


/***/ })

}]);